<template>
	<div class="common-date-header">
		<ul class="common-date-header__selector">
			<li :class="['common-date-header__selector--item', { 'is-active': selectType === 'day' }]" @click="onSelectType('day')">日</li>
			<li :class="['common-date-header__selector--item', { 'is-active': selectType === 'week' }]" @click="onSelectType('week')">週</li>
			<li :class="['common-date-header__selector--item', { 'is-active': selectType === 'month' }]" @click="onSelectType('month')">月</li>
			<li :class="['common-date-header__selector--item', { 'is-active': selectType === 'year' }]" @click="onSelectType('year')">年</li>
		</ul>
		<div class="common-date-header__view">
			<svg @click="reloadDate('pre')" class="common-date-header__view--pre" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path d="M13 15.9999L7 10.0161L13 3.99994" stroke-width="2" />
			</svg>
			<span
				@click="reloadDate('now')"
				:class="[
					'common-date-header__view--date',
					{ 'is-date': selectType === 'day' },
					{ 'is-disabled': isDisabledNext }
				]"
			>
				{{ computedDate }}
			</span>
			<svg
				@click="reloadDate('post')"
				:class="[
					'common-date-header__view--post',
					{ 'is-disabled': isDisabledNext }
				]"
				width="16"
				height="14"
				viewBox="0 0 16 14"
				fill="none"
			>
				<path d="M1 1.00006L7 6.98395L1 13.0001" stroke-width="2" />
			</svg>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'CommonDateHeader',
	components: {
	},
	data () {
		return {
			isDisabledNext: true,
			selectType: 'day',
			fromDate: 0,
			toDate: 0
		}
	},
	props: {
		targetDate: {	// 初期表示unix時間
			type: Number,
			default: null
		}
	},
	mounted () {
		this.dateSetting(this.targetDate)
	},
	beforeDestroy () {
	},
	computed: {
		// 日付表示
		computedDate () {
			let duration = ''
			switch (this.selectType) {
				case 'day':
					duration = this.isDisabledNext ? moment.unix(this.fromDate).format('YYYY年MM月DD日') : moment.unix(this.fromDate).format('YYYY年MM月DD日(ddd)')
					break
				case 'week':
					duration = `${moment.unix(this.fromDate).format('YYYY年MM月DD日')}〜${moment.unix(this.toDate).format('YYYY年MM月DD日')}`
					break
				case 'month':
					duration = `${moment.unix(this.fromDate).format('YYYY年MM月DD日')}〜${moment.unix(this.toDate).format('YYYY年MM月DD日')}`
					break
				case 'year':
					duration = `${moment.unix(this.fromDate).format('YYYY年MM月')}〜${moment.unix(this.toDate).format('YYYY年MM月')}`
					break
			}
			return duration
		}
	},
	methods: {
		// 日・週・月・年のボタンを押下した際の処理
		onSelectType (type) {
			this.selectType = type
			this.dateSetting()
		},

		// 日付を変更するメソッド
		reloadDate (type) {
			let date = 0
			const unixOneDay = 86400

			switch (type) {
				case 'pre':
					date = this.fromDate - unixOneDay
					break
				case 'now':
					date = moment().unix()
					break
				case 'post':
					date = this.toDate + unixOneDay
					break
			}

			this.dateSetting(date)
		},

		// 日付のfrom、toを設定するメソッド
		dateSetting (date) {
			const targetDate = date ? moment.unix(date) : moment()

			switch (this.selectType) {
				case 'day':
					// 今日なら「>」ボタンをdisabledにする
					this.isDisabledNext = moment().format('YYYY-MM-DD') === targetDate.format('YYYY-MM-DD')

					this.fromDate = targetDate.startOf('day').unix()
					this.toDate = targetDate.endOf('day').unix()
					break
				case 'week':
					this.fromDate = targetDate.startOf('week').unix()
					this.toDate = targetDate.endOf('week').unix()

					// 今週なら「>」のボタンをdisabledにする
					this.isDisabledNext = moment().unix() < this.toDate
					break
				case 'month':
					// 今月なら「>」のボタンをdisabledにする
					this.isDisabledNext = moment().format('YYYY-MM') === targetDate.format('YYYY-MM')

					this.fromDate = targetDate.startOf('month').unix()
					this.toDate = targetDate.endOf('month').unix()
					break
				case 'year':
					// 今年なら「>」のボタンをdisabledにする
					this.isDisabledNext = moment().format('YYYY') === targetDate.format('YYYY')

					this.fromDate = targetDate.startOf('year').unix()
					this.toDate = targetDate.endOf('year').unix()
					break
			}

			// 親コンポーネントにfrom、toのunix時間とselectTypeを返す
			this.$emit('reload', { from: this.fromDate, to: this.toDate, type: this.selectType })
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止
$spacing-1: 0.062rem;
$spacing-3: 0.187rem;
$font-size-9: 0.562rem;
$font-size-11: 0.687rem;

$color-enabled: #999999;
$color-disabled: #CCCCCC;

.common-date-header {
	font-family: $lp-family-primary;

	// mplusのジャギー対策
	h2, li, p, span { transform: rotate(0.05deg); }

	&__selector {
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: $spacing-10;
		margin: 0;
		list-style: none;
		background-color: $primary;

		&--item {
			padding: $spacing-10;
			background-color: $primary;
			font-size: $font-size-11;
			color: $text-seconday;
			text-align: center;
			cursor: pointer;
			border: $spacing-1 solid $_white;
			line-height: $line-height-1;

			& + & {
				margin-left: -#{$spacing-1};
				width: calc(25% + #{$spacing-1});
			}

			&:first-of-type {
				width: 25%;
				border-radius: $spacing-3 0px 0px $spacing-3;
			}

			&:last-of-type {
				width: 25%;
				border-radius: 0px $spacing-3 $spacing-3 0px;
			}

			&.is-active {
				background-color: $background-primary;
				color: $primary;
				pointer-events: none;
			}
		}
	}

	&__view {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: $spacing-14 $spacing-10;
		margin: 0;
		background-color: $background-primary;
		font-family: $family-primary;

		&--date {
			display: flex;
			align-items: center;
			font-size: $font-size-14;
			font-weight: normal;
			cursor: pointer;

			&.is-disabled {
				pointer-events: none;

				&.is-date::after {
					content: '今日';
					display: block;
					padding: 0 $spacing-6;
					margin: 0 0 0 $spacing-6;
					background-color: $primary;
					font-size: $font-size-9;
					color: $text-seconday;
					border-radius: $spacing-2;
				}
			}
		}

		& > svg path { stroke: $color-enabled; }

		&--pre ,
		&--post { cursor: pointer; }

		&--post.is-disabled {
			cursor: none;
			pointer-events: none;

			path { stroke: $color-disabled; }
		}
	}
}
</style>
